import { combineReducers } from "redux";
import {
  fetching,
  submitting,
  items,
  togglable,
  selectable,
} from "./resource";

export default combineReducers({
  selectedItem: selectable("topics"),
  isFetching: fetching("topics"),
  isSubmitting: submitting("topics"),
  items: items("topics"),
  showAddModal: togglable("addModal"),
});
